import { Component, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { LoggerService, LogLevel } from 'app/services/logger.service';
import { AuthType } from 'app/models/auth-type';

@Component({
    selector: 'admin-splash',
    templateUrl: './admin-splash.component.html',
    styleUrls: ['./admin-splash.component.scss'],
    imports: [RouterModule, CommonModule]
})
export class AdminSplashComponent implements OnInit {
    private oidcSecurityService = inject(OidcSecurityService);
    private logger: ReturnType<LoggerService['getScopedLogger']>;
    private loggerService = inject(LoggerService);

    constructor() {
        this.loggerService.setLogLevel('AdminSplashComponent', LogLevel.WARN);
        this.logger = this.loggerService.getScopedLogger('AdminSplashComponent');
    }

    public ngOnInit(): void {
        this.logger.debug("Authorizing: ", AuthType.EMPLOYEE_FAC);
        this.oidcSecurityService.checkAuthMultiple().subscribe({
            next: (results) => {
                this.logger.debug('Check multiple auth results:', JSON.stringify(results, null, 2));
                for (const i in results) {
                    const login = results[i];
                    if (login.configId == AuthType.EMPLOYEE_FAC) {
                        if (login.isAuthenticated) {
                            this.logger.debug(`User authenticated with config: ${login.configId}, calling authorize now`);
                            this.oidcSecurityService.authorize(AuthType.EMPLOYEE_FAC);
                        } else {
                            this.logger.debug(`User NOT authenticated with config: ${login.configId}`);
                        }
                    }
                }
            },
            error: (err) => {
                this.logger.error('Auth error during checkAuthMultiple:', JSON.stringify(err, null, 2));
            }
        });
    }

    public redirectToLogin(): void {
        this.oidcSecurityService.authorize(AuthType.EMPLOYEE_FAC);
    }
}

